export default __webpack_public_path__ + "static/auto-assign-2ea8b9970c1e9c42e8a107986a391a1b.png";